<template>
  <v-layout row wrap fill-height>
    <v-flex xs12>
      <v-card class="notification-header">
        <Toolbar class="toolbar">
          <div class="mt-5">
            <v-toolbar-title class="subheading mt-3">{{
              $t("Notifications")
            }}</v-toolbar-title>
          </div>

          <v-spacer></v-spacer>
        </Toolbar>
        <div class="alert-container-height">
          <template>
            <v-layout
              v-for="item in notifications"
              :key="item._id"
              row
              wrap
              class="primaryText--text bg-alert-list mx-2 mb-2 pa-2 alert-label elevation-4"
              :class="[
                indicator(item.type),
              ]"
            >
              <v-flex xs12 sm6 md6>
                <div class="mb-2">
                  <span class="title font-weight-bold">{{ $t(item.title) }}</span>
                </div>
                <div class="caption truncate font-italic font-weight-light">
                  <span>{{ $t(item.message) }}</span>
                </div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex class="d-flex align-center">
                <v-tooltip bottom>
                  <template slot="activator">
                    <span class="text-capitalize">{{ $t(item.equipment) }}</span>
                  </template>
                  <span>{{ item.type }}</span>
                </v-tooltip>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <div class="caption extraGrey--text darken-3">
                  {{ $t("Added by") }}: {{ item.added_by }}
                </div>
                <div class="caption extraGrey--text darken-3">
                  {{ $t("Added on") }}:
                  {{ item.added_on ? formatDate(item.added_on) : "NA" }}
                </div>
              </v-flex>
            </v-layout>
          </template>
        </div>

        <v-layout class="legend-background" justify-end>
          <v-flex
            order-xs1
            order-md2
            shrink
            :ml-auto="$vuetify.breakpoint.smAndDown"
            :mr-auto="$vuetify.breakpoint.smAndDown"
          >
            <span class="primaryText--text"
              >{{ itemFrom }} - {{ itemTo }} of {{ getGeneralState('totalNotifications') }}</span
            >
            <span class="action">
              <v-btn
                avatar
                fab
                small
                :disabled="!hasPrevious"
                class="fab-btn-xs"
                @click="previous"
              >
                <v-icon>navigate_before</v-icon>
              </v-btn>
              <v-btn
                avatar
                fab
                small
                :disabled="!hasNext"
                class="fab-btn-xs"
                @click="next"
              >
                <v-icon>navigate_next</v-icon>
              </v-btn>
            </span>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Notification from "@/services/Notification";
import { NotificationMixin } from '@/util/mixin/NotificationMixin'
const momentTz = require('moment-timezone')

export default {
  mixins: [NotificationMixin],
  data () {
    return {
      itemPerPage: 50,
      page: 1,
      notifications: []
    }
  },
  mounted() {
    const idCsv = this.getPlantList.map(el => el.id).join();
    const base64data = btoa(idCsv);

    Notification.fetchNotificationCount(base64data).then((res) => {
      this.SET_NOTIFICATION_COUNT(res.data.message);
      this.fetchNotificationForCurrentPage()
    });
  },
  computed: {
    ...mapGetters(['getGeneralState', 'getPlantList', 'getActivePlantTimezone']),
    notificationsLoaded() {
      return this.itemPerPage * (this.page-1)
    },
    isNext() {
      return this.page * this.itemPerPage < this.getGeneralState('totalNotifications')
    },
    hasNext() {
      return this.itemTo < this.getGeneralState('totalNotifications')
    },
    hasPrevious() {
      return this.itemFrom > 1
    },
    itemFrom() {
      if (this.page === 1 && this.getGeneralState('totalNotifications') > 0) {
        return 1
      }
      return (this.page - 1) * this.itemPerPage
    },
    itemTo() {
      if ((this.page * this.itemPerPage) > this.getGeneralState('totalNotifications')) {
        return this.getGeneralState('totalNotifications')
      }
      return this.page * this.itemPerPage
    },
    notificationsToBeLoaded() {
      return this.itemTo - this.notificationsLoaded
    },
    totalPages() {
      let pages = 0
      if (this.getGeneralState('totalNotifications')) {
        pages = Math.floor(this.getGeneralState('totalNotifications') / this.itemPerPage)
        if (this.getGeneralState('totalNotifications') % this.itemPerPage > 0) {
          pages++
        }
      }
      return pages
    }
  },
  methods: {
    ...mapMutations(['SET_PROGRESS_BAR', 'SET_NOTIFICATION_COUNT']),
    ...mapActions(['fetchNotificationCount']),
    formatDate(time) {
      return momentTz(time, 'X').tz(this.getActivePlantTimezone).format('YYYY-MM-DD HH:mm:ss')
    },
    indicator(status) {
      return {
        "alert-label-err": status === "error",
        "alert-label-success": status === "success",
        "alert-label-ack": status === "warning",
      };
    },
    fetchNotificationForCurrentPage() {
      if (this.notificationsLoaded < this.itemTo) {
        const idCsv = this.getPlantList.map(el => el.id).join();
        const base64data = btoa(idCsv);

        this.SET_PROGRESS_BAR(true);
        Notification.fetchNotification(
          base64data,
          this.notificationsLoaded,
          this.notificationsToBeLoaded
        )
        .then((res) => {
          this.notifications = res.data.message;
          this.SET_PROGRESS_BAR(false);
        })
        .catch((err) => {
          console.log(err);
          this.SET_PROGRESS_BAR(false);
        });
      }
    },
    previous() {
      if (this.page > 1) this.page -= 1;
    },
    next() {
      if (this.isNext) this.page += 1;
    }
  },
  watch: {
    page() {
      this.fetchNotificationForCurrentPage()
    }
  }
}
</script>

<style scoped>
.fab-btn-xs {
  height: 20px;
  width: 20px;
}

.notification-card {
  max-height: 600px;
  height: 600px;
  overflow-y: auto
}
.notification-text{
  height: 44px;
}

.theme--dark .notification-color {
  background: #414964;
}

.theme--light .notification-color {
  background: #fff;
}

.alert-container-height {
  height: 650px;
  max-height: 650px;
  overflow-y: scroll;
  overflow-x: hidden;
}


.theme--dark .notification-header {
  background: #000427;
}

.theme--light .notification-header {
  background: #fff;
}

.toolbar {
  height: 100px;
}

.alert-label {
  border-radius: 10px;
  border-left: 15px;
  border-right: 0px;
  border-top: 0px;
  border-bottom: 0px;
  border-style: solid;
}

.alert-label-err {
  border-color: var(--v-error-base);
}

.alert-label-ack {
  border-color: var(--v-warning-base);
}

.alert-label-success {
  border-color: var(--v-success-base);
}

</style>
